import React, { useEffect, useState } from 'react';
import Modal from 'components/Tvendo/Common/ModalBase';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { wsGetAll } from 'services/WService';

export default function ModalSeller(props) {
  const docPermission = props.model;

  const [docsSunat, setDocsSunat] = useState([]);

  async function listDocsSunat() {
    let response = await wsGetAll('base/sunat-document-type/prt');
    if (response.success) setDocsSunat(response.data);
  }

  useEffect(() => {
    if (docPermission.open) {
      listDocsSunat();
    }
  }, [docPermission.open]);

  return (
    <Modal
      title="Permiso documento"
      model={docPermission}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={() => {
        props.reload();
        if (docPermission.document == props.documentSelected?.document) {
          props.setReloadChild(!props.reloadChild);
        }
      }}
      dataForce={{
        oauth_user_id: props.idUser
      }}
      entity="prt/document-permission"
    >
      <FormControl fullWidth margin="normal" size="small" required>
        <InputLabel>Documento</InputLabel>
        <Select
          defaultValue={docPermission.document || ''}
          inputProps={{
            name: 'document'
          }}
        >
          {docsSunat.map((item, i) => {
            return (
              <MenuItem key={i} value={item.code}>
                {item.description}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Activo</InputLabel>
        <Select
          defaultValue={docPermission.active || 'Y'}
          inputProps={{
            name: 'active'
          }}
        >
          <MenuItem value="Y">Si</MenuItem>
          <MenuItem value="N">No</MenuItem>
        </Select>
      </FormControl>
    </Modal>
  );
}
